// This object is passed directly to Blockly, hence the colour* fields need to
// be named exactly as they are, including the UK spelling of "colour".
const blockColors = {
    // PixelBlock Python Categories (Scratch standard)
    looks: {
        colourPrimary: '#9966FF',
        colourSecondary: '#855CD6',
        colourTertiary: '#774DCB',
        colourQuaternary: '#774DCB'
    },
    control: {
        colourPrimary: '#FFAB19',
        colourSecondary: '#EC9C13',
        colourTertiary: '#CF8B17',
        colourQuaternary: '#CF8B17'
    },
    sensing: {
        colourPrimary: '#5CB1D6',
        colourSecondary: '#47A8D1',
        colourTertiary: '#2E8EB8',
        colourQuaternary: '#2E8EB8'
    },
    operators: {
        colourPrimary: '#59C059',
        colourSecondary: '#46B946',
        colourTertiary: '#389438',
        colourQuaternary: '#389438'
    },
    variables: {
        colourPrimary: '#FF8C1A',
        colourSecondary: '#FF8000',
        colourTertiary: '#DB6E00',
        colourQuaternary: '#DB6E00'
    },
    lists: {
        colourPrimary: '#FF661A',
        colourSecondary: '#FF5500',
        colourTertiary: '#E64D00',
        colourQuaternary: '#E64D00'
    },
    output: {
        colourPrimary: '#9966FF',
        colourSecondary: '#855CD6',
        colourTertiary: '#774DCB',
        colourQuaternary: '#774DCB'
    },
    decisions: {
        colourPrimary: '#FFAB19',
        colourSecondary: '#EC9C13',
        colourTertiary: '#CF8B17',
        colourQuaternary: '#CF8B17'
    },
    iteration: {
        colourPrimary: '#FFAB19',
        colourSecondary: '#EC9C13',
        colourTertiary: '#CF8B17',
        colourQuaternary: '#CF8B17'
    },
    input: {
        colourPrimary: '#5CB1D6',
        colourSecondary: '#47A8D1',
        colourTertiary: '#2E8EB8',
        colourQuaternary: '#2E8EB8'
    },
    values: {
        colourPrimary: '#59C059',
        colourSecondary: '#46B946',
        colourTertiary: '#389438',
        colourQuaternary: '#389438'
    },
    conversions: {
        colourPrimary: '#59C059',
        colourSecondary: '#46B946',
        colourTertiary: '#389438',
        colourQuaternary: '#389438'
    },
    dictionaries: {
        colourPrimary: '#F97316',
        colourSecondary: '#EA580C',
        colourTertiary: '#C2410C',
        colourQuaternary: '#C2410C'
    },
    functions: {
        colourPrimary: '#6366F1',
        colourSecondary: '#4F46E5',
        colourTertiary: '#4338CA',
        colourQuaternary: '#4338CA'
    },
    turtle: {
        colourPrimary: '#22C55E',
        colourSecondary: '#16A34A',
        colourTertiary: '#15803D',
        colourQuaternary: '#15803D'
    },
    classes: {
        colourPrimary: '#A855F7',
        colourSecondary: '#9333EA',
        colourTertiary: '#7E22CE',
        colourQuaternary: '#7E22CE'
    },

    // Scratch standard legacy styles
    motion: {
        colourPrimary: '#4C97FF',
        colourSecondary: '#4280D7',
        colourTertiary: '#3373CC',
        colourQuaternary: '#3373CC'
    },
    looks: {
        colourPrimary: '#9966FF',
        colourSecondary: '#855CD6',
        colourTertiary: '#774DCB',
        colourQuaternary: '#774DCB'
    },
    sounds: {
        colourPrimary: '#CF63CF',
        colourSecondary: '#C94FC9',
        colourTertiary: '#BD42BD',
        colourQuaternary: '#BD42BD'
    },
    control: {
        colourPrimary: '#10B981',
        colourSecondary: '#059669',
        colourTertiary: '#047857',
        colourQuaternary: '#047857'
    },
    event: {
        colourPrimary: '#FFBF00',
        colourSecondary: '#E6AC00',
        colourTertiary: '#CC9900',
        colourQuaternary: '#CC9900'
    },
    sensing: {
        colourPrimary: '#5CB1D6',
        colourSecondary: '#47A8D1',
        colourTertiary: '#2E8EB8',
        colourQuaternary: '#2E8EB8'
    },
    pen: {
        colourPrimary: '#22C55E',
        colourSecondary: '#16A34A',
        colourTertiary: '#15803D',
        colourQuaternary: '#15803D'
    },
    data: {
        colourPrimary: '#EE7D16',
        colourSecondary: '#D96E0F',
        colourTertiary: '#BF5E09',
        colourQuaternary: '#BF5E09'
    },
    data_lists: {
        colourPrimary: '#14B8A6',
        colourSecondary: '#0D9488',
        colourTertiary: '#0F766E',
        colourQuaternary: '#0F766E'
    },
    more: {
        colourPrimary: '#6366F1',
        colourSecondary: '#4F46E5',
        colourTertiary: '#4338CA',
        colourQuaternary: '#4338CA'
    },
    text: '#FFFFFF',
    workspace: '#F9F9F9',
    toolboxHover: '#3B82F6',
    toolboxSelected: '#E9EEF2',
    toolboxText: '#575E75',
    toolbox: '#FFFFFF',
    flyout: '#F9F9F9',
    scrollbar: '#CECDCE',
    scrollbarHover: '#CECDCE',
    textField: '#FFFFFF',
    textFieldText: '#575E75',
    insertionMarker: '#000000',
    insertionMarkerOpacity: 0.2,
    dragShadowOpacity: 0.6,
    stackGlow: '#FFF200',
    stackGlowSize: 4,
    stackGlowOpacity: 1,
    replacementGlow: '#FFFFFF',
    replacementGlowSize: 2,
    replacementGlowOpacity: 1,
    colourPickerStroke: '#FFFFFF',
    // CSS colours: support RGBA
    fieldShadow: 'rgba(255, 255, 255, 0.3)',
    dropDownShadow: 'rgba(0, 0, 0, .3)',
    numPadBackground: '#547AB2',
    numPadBorder: '#435F91',
    numPadActiveBackground: '#435F91',
    numPadText: 'white', // Do not use hex here, it cannot be inlined with data-uri SVG
    valueReportBackground: '#FFFFFF',
    valueReportBorder: '#AAAAAA',
    menuHover: 'rgba(0, 0, 0, 0.2)'
};

export {
    blockColors
};
